var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.445 2.106a10 10 0 0 1 6.561 1.218.6.6 0 0 1-.6 1.04 8.814 8.814 0 0 0-10.94 1.723 8.815 8.815 0 0 0-.613 11.06 8.811 8.811 0 0 0 15.784-6.91.601.601 0 0 1 1.176-.24 10.013 10.013 0 1 1-11.368-7.89m10.614 2.01a.5.5 0 0 1 .707.707l-9.412 9.412a.5.5 0 0 1-.707 0l-2.824-2.824a.5.5 0 0 1 .707-.707l2.47 2.47z"
  })));
};
export default SvgCheckCircle;